import { ModuleRegistry, ValidationModule } from 'ag-grid-community'
import {
  AllEnterpriseModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  DateFilterModule,
  LicenseManager,
  ServerSideRowModelModule,
  SetFilterModule,
  TextFilterModule
} from 'ag-grid-enterprise'

/* Registered once at import time, shared by every records grid so the license lives in one place. */
ModuleRegistry.registerModules([
  AllEnterpriseModule,
  ColumnsToolPanelModule,
  ColumnMenuModule,
  ContextMenuModule,
  ServerSideRowModelModule,
  SetFilterModule,
  DateFilterModule,
  TextFilterModule,
  ValidationModule
])

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-077987}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Onyxia_Cyber_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Onyxia}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Onyxia}_need_to_be_licensed___{Onyxia}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{25_February_2026}____[v3]_[01]_MTc3MTk3NzYwMDAwMA==96bb6539a7b3dc7650ef4ae6e514c8e4'
)
